import Head from 'next/head';
import React from 'react';
import { IMetaHeader } from '../../types/@types/generated/contentful';

type Props = {
  metaHeader: IMetaHeader | undefined;
  canonicalLink?: string;
};

const MetaHeader = ({ metaHeader }: Props) => {
  const {
    seoDescription,
    seoTitle,
    socialDescription,
    socialImage,
    socialImageHeight,
    socialImageWidth,
    socialTitle,
    canonicalLink,
  } = metaHeader?.fields || {};
  return (
    <Head>
      <title>{seoTitle}</title>
      <meta key="description" name="description" content={seoDescription} />
      <meta key="og:title" property="og:title" content={socialTitle} />
      <meta key="og:description" property="og:description" content={socialDescription} />
      {canonicalLink && <link rel="canonical" href={canonicalLink} />}
      {socialImage && (
        <meta
          key="og:image"
          property="og:image"
          content={`https:${socialImage?.fields?.file?.url}`}
        />
      )}
      {socialImage && socialImageWidth && (
        <meta key="og:image:width" property="og:image:width" content={String(socialImageWidth)} />
      )}
      {socialImage && socialImageHeight && (
        <meta
          key="og:image:height"
          property="og:image:height"
          content={String(socialImageHeight)}
        />
      )}
      <script
        key="schema.org"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'http://schema.org/',
            '@type': 'organization',
            name: seoTitle,
            image: [`https:${socialImage?.fields?.file?.url}`],
            description: seoDescription,
          }),
        }}
      />
    </Head>
  );
};

export default MetaHeader;
